export const constants = {
  NOT_AVAILABLE: 'n/a',
  FRISK_NOT_AVAILABLE: '--',
  NOT_AVAILABLE_YET: '-',
  NULL: '!!!',
};

export const continents = {
  NORTH_AMERICA: 'NA',
  EUROPE: 'EUR',
  MEXICO: 'MEX',
  AUSTRALIA: 'AUS',
  ASIA: 'ASIA',
};
export type ContinentId = (typeof continents)[keyof typeof continents];

export const continentsNames = {
  NORTH_AMERICA: 'North America',
  EUROPE: 'Europe',
  MEXICO: 'Mexico',
  AUSTRALIA: 'Australia',
  ASIA: 'Asia',
};

export const models = {
  ECMWF_OP: 'ECMWF_OP',
  ECMWF_ENS: 'ECMWF_ENS',
  GFS_OP: 'GFS_OP',
  GFS_ENS: 'GFS_ENS',
  GEM_OP: 'GEM_OP',
  GEM_ENS: 'GEM_ENS',
};

export const diffTags = {
  minFeelsLike: 'minFeelsLikeDiff',
  maxFeelsLike: 'maxFeelsLikeDiff',
  peakMin: 'offPeakMinDiff',
  peakMax: 'onPeakMaxDiff',
  minTemp: 'minTempDiff',
  maxTemp: 'maxTempDiff',
  hdd: 'hddDiff',
  cdd: 'cddDiff',
  gasDayMin: 'gasDayMinTempDiff',
  gasDayMax: 'gasDayMaxTempDiff',
};
export const dfnTags = {
  aggMinTemp: 'aggMinTemp',
  aggMaxTemp: 'aggMaxTemp',
  minTemp: 'minTemp',
  maxTemp: 'maxTemp',
  offPeakMin: 'offPeakMin',
  onPeakMax: 'onPeakMax',
  gasDayMinTemp: 'gasDayMinTemp',
  gasDayMaxTemp: 'gasDayMaxTemp',
};

export const cellTags = {
  aggMinTemp: 'aggMinTemp',
  aggMaxTemp: 'aggMaxTemp',
  minTemp: 'minTemp',
  maxTemp: 'maxTemp',
  onPeakMax: 'onPeakMax',
  offPeakMin: 'offPeakMin',
  minFeelsLike: 'minFeelsLike',
  maxFeelsLike: 'maxFeelsLike',
  gasDayMinTemp: 'gasDayMinTemp',
  gasDayMaxTemp: 'gasDayMaxTemp',
};
export const MIN_REQUIRED_HEIGHT = 1000;
export const GRID_GAP = 12;
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';

export const ONE_HOUR_MS = 3600 * 1000;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
